export default __webpack_public_path__ + "static/media/AmericanTouristerIvy1.4bcb6594.jpg";